import * as React from 'react';
import { Application } from '~/infrastructure/mam/Aplication';
import { ConsoleErrorLogger, ErrorLogger } from '~/infrastructure/mam/ErrorLogger';

import { handleError } from './ErrorHandler';

import defaultApplicationServiceFactory from '~/infrastructure/mam/Aplication/defaultApplicationServiceFactory';

import { Store } from '~/Store';

import type { AccessTokenStorage } from '~/infrastructure/mam/Api/AccessTokenStorage';

class PMAccessTokenStorage implements AccessTokenStorage {
	private readonly store: Store;
	constructor(store: Store) {
		this.store = store;
	}

	load() {
		return this.store.getState().accessToken.accessToken?.token || null;
	}
	remove() {}
	save() {}
}

const HooksApiContainer = ({
	apiBaseUrl,
	children,
	store,
}: {
	apiBaseUrl: string;
	children: React.ReactNode;
	store: Store;
}) => {
	const errorLogger: ErrorLogger =
		/*typeof process.env.SENTRY_URL === 'string' && typeof process.env.APP_BUILD === 'string'
		? new SentryErrorLogger(process.env.SENTRY_URL, process.env.APP_BUILD)
		: */ new ConsoleErrorLogger();

	return (
		<Application
			apiBaseUrl={apiBaseUrl}
			errorLogger={errorLogger}
			pigeonAuthProvider={process.env.PIGEON_AUTH_PROVIDER ?? 'app-mam@cogvio.com'}
			pigeonBaseUrl={process.env.PIGEON_BASE_URL ?? 'https://notifications-api.cogvio.com/api/v1/'}
			serviceFactory={{
				...defaultApplicationServiceFactory,
				createErrorHandler: () => ({
					handle(error) {
						store.dispatch(handleError(error));
						return null;
					},
					handleApiFailure() {
						return null;
					},
				}),
				createAccessTokenStorage: () => new PMAccessTokenStorage(store),
			}}
		>
			{children}
		</Application>
	);
};

export default React.memo(HooksApiContainer);
